import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { warehouseFloor, WarehouseFloorManipulationViewModel } from "./warehouseFloorManipulation-viewModel"

export class WarehouseFloorManipulationView extends View<WarehouseFloorManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-1CB80060-688B-43C6-9D55-BA381586352C"
    }
    loadHtml(): string {
        let element = require('./warehouseFloorManipulation.html').default;
        let style = require('./warehouseFloorManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set warehouseFloor(v: ObservableArray<warehouseFloor>) { this._warehouseFloor = v; } public get warehouseFloor(): ObservableArray<warehouseFloor> { return this._warehouseFloor;} private _warehouseFloor: ObservableArray<warehouseFloor>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    requestWarehouseFloorCreation(){
        this.dataContext.requestWarehouseFloorCreation();
    }
}
